import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ResponseBase} from "../../data";
import {ParamItem} from "../../data/deviceParam";

export interface DeviceParamState {
    response: ResponseBase | null
    isLoading: boolean;
    error: ResponseBase | null;
    commands: ParamItem[];
}

const initialDeviceParamsState: DeviceParamState = {
    isLoading: false,
    response: null,
    error: null,
    commands: [],
};

const deviceParamsSlice = createSlice({
    name: "deviceParamsSlice",
    initialState: initialDeviceParamsState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
        setDeviceParamList(state, action: PayloadAction<ParamItem[]>) {
            state.commands = action.payload;
            state.isLoading = false;
        },
        setResponse(state, action: PayloadAction<ResponseBase | null>) {
            state.response = action.payload;
            state.isLoading = false;
        },
        setError(state, action: PayloadAction<ResponseBase | null>) {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});

export const deviceParamsActions = deviceParamsSlice.actions;
export default deviceParamsSlice;
